import styled, { css } from 'styled-components';
import { colors, font, radius, shadow } from '../../../styles/theme/tokens';

const STATUS = {
  ok: { color: colors.success, soft: colors.successSoft, bar: colors.brand },
  low: { color: colors.amberDeep, soft: colors.amberSoft, bar: colors.amber },
  empty: { color: colors.danger, soft: colors.dangerSoft, bar: colors.danger },
};

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1040px;
`;

export const Stats = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
`;

export const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 22px;
  border-radius: ${radius.lg};
  background: ${colors.surface};
  border: 1px solid ${colors.line};
  box-shadow: ${shadow.card};
`;

export const StatLabel = styled.span`
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 600;
  color: ${colors.muted};
`;

export const StatValue = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: ${font.text};
  font-size: 34px;
  font-weight: 800;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
  color: ${colors.ink};

  span {
    font-size: 18px;
    font-weight: 700;
    color: ${colors.muted};
  }

  svg {
    color: ${(props) => STATUS[props.$status || 'ok'].color};
  }
`;

export const Progress = styled.div`
  height: 8px;
  margin-top: 4px;
  border-radius: ${radius.pill};
  overflow: hidden;
  background: ${colors.brandSoft};
`;

export const ProgressFill = styled.div`
  height: 100%;
  border-radius: inherit;
  background: ${(props) => STATUS[props.$status].bar};
  transition: width 0.6s ease-out;
`;

export const StatHint = styled.p`
  padding: 8px 12px;
  border-radius: ${radius.sm};
  font-family: ${font.text};
  font-size: 13px;
  font-weight: 700;
  color: ${(props) => STATUS[props.$status].color};
  background: ${(props) => STATUS[props.$status].soft};
`;

export const PackageTitle = styled.h2`
  font-family: ${font.text};
  font-size: 22px;
  font-weight: 800;
  color: ${colors.ink};
  margin-bottom: -8px;
`;

export const OtherPackages = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
`;

export const Package = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 20px;
  border-radius: ${radius.lg};
  background: ${colors.surface};
  border: 1.5px solid ${colors.line};
  box-shadow: ${shadow.card};

  ${(props) => props.$current && css`
    border-color: ${colors.brand};
    background: linear-gradient(180deg, ${colors.brandSoft} 0%, ${colors.surface} 70%);
  `}
`;

export const PackageTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
`;

export const PackageHeader = styled.h3`
  font-family: ${font.text};
  font-size: 16px;
  font-weight: 700;
  color: ${colors.muted};
`;

export const CurrentBadge = styled.span`
  padding: 4px 10px;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: 12px;
  font-weight: 800;
  color: #FFFFFF;
  background: ${colors.brand};
`;

export const DiscountedPrice = styled.p`
  font-family: ${font.text};
  font-size: 28px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: ${colors.ink};
`;

export const PerLessonPrice = styled.p`
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 600;
  color: ${colors.muted};
`;

export const Saving = styled.p`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  font-family: ${font.text};
  font-size: 13px;
  font-weight: 700;
  color: ${colors.success};
`;

export const OriginalPrice = styled.span`
  font-weight: 600;
  color: ${colors.muted};
  text-decoration: line-through;
`;
